import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6b41b24&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e6b41b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b41b24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6b41b24')) {
      api.createRecord('e6b41b24', component.options)
    } else {
      api.reload('e6b41b24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e6b41b24&scoped=true&", function () {
      api.rerender('e6b41b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/install/index.vue"
export default component.exports